module.exports = __webpack_public_path__ + "img/logo.6a88e67b.6a88e67b.png";